import { DataTable } from "lib/@components/data-table/data-table"
import { QuickWinRow } from "./quick-win-row"

export function QuickWinTable({ results }) {
    const columns = buildColumns()

    return (
        <DataTable
            columns={columns}
            RowComponent={<QuickWinRow />}
            items={results}
            keyFn="key"
            sortKey="quick-win-sort"
            pageSizeKey="quick-win-page-size"
            defaultSort={{ field: "bestCloseness", descending: true }}
            itemLabel="tickets"
        />
    )

    function buildColumns() {
        return [
            { field: "key", label: "Ticket", sortable: true, width: 140 },
            { field: "summary", label: "Summary", sortable: true },
            { field: "status", label: "Status", sortable: true, width: 180 },
            { field: "bestCloseness", label: "Best closeness", sortable: true, align: "right", width: 140 },
        ]
    }
}
